import React from 'react';
import { Provider } from '../../../provider/types';
import ProviderCard from './ProviderCard';
import ProviderGrid from './ProviderGrid';
import ProviderList from './ProviderList';

interface ProviderDisplayProps {
  providers: { node: Provider }[];
  selectedProviders: Provider | Provider[] | null;
  onProviderClick: (provider: Provider) => void;
  isClickable: boolean;
  nodeData: any;
}

const ProviderDisplay: React.FC<ProviderDisplayProps> = ({
  providers,
  selectedProviders,
  onProviderClick,
  isClickable,
  nodeData
}) => {
  // Extract settings from nodeData or use defaults
  const settings = nodeData?.settings || {
    showPhotos: true,
    showAvailability: true,
    displayStyle: 'cards',
    itemsPerRow: 3,
    numberRows: 2,
    colors: {}
  };

  // Extract colors from settings
  const colors = settings?.colors || {};

  // Determine which component to render based on displayStyle
  switch (settings.displayStyle) {
    case 'cards':
      return (
        <ProviderCard
          providers={providers}
          selectedProviders={selectedProviders}
          onProviderClick={onProviderClick}
          isClickable={isClickable}
          showPhotos={settings.showPhotos}
          showAvailability={settings.showAvailability}
          colors={colors}
          itemsPerRow={settings.itemsPerRow || 3}
        />
      );

    case 'grid':
      return (
        <ProviderGrid
          providers={providers}
          selectedProviders={selectedProviders}
          onProviderClick={onProviderClick}
          isClickable={isClickable}
          colors={colors}
          itemsPerRow={settings.itemsPerRow || 4}
        />
      );

    case 'list':
    default:
      return (
        <ProviderList
          providers={providers}
          selectedProviders={selectedProviders}
          onProviderClick={onProviderClick}
          isClickable={isClickable}
          showPhotos={settings.showPhotos}
          showAvailability={settings.showAvailability}
          colors={colors}
        />
      );
  }
};

export default ProviderDisplay;
